import {commonConstants} from '../_constants';
import { initialState } from '../_helpers';

export function workFlowProcess(state=initialState.workFlowProcess, action) {
    switch (action.type) {
        case commonConstants.WORKFLOW_PROCESS_SUCCESS:
            return Object.assign([], state, action.workFlowProcess);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/workFlowProcess.reducer.js